import { useHistory } from 'react-router-dom'

import { formatMoney } from 'common'

import { ProductIds } from 'core'

import { Button } from 'common/components'
import { formatYearV2, parseZoneFormat } from 'common/dateFormatters'
import { ROUTE_PATHS } from 'common/routePaths'

type TotalReimbursementAmountProps = {
  totalReimbursementAmount: number
  totalReimbursementDue: number
  productId: number
  planPeriod: any
}

const TotalReimbursementAmount = ({
  totalReimbursementAmount,
  totalReimbursementDue,
  planPeriod,
  productId,
}: TotalReimbursementAmountProps) => {
  const history = useHistory()

  return (
    <>
      {totalReimbursementAmount > 0 && (
        <div className="flex flex_space_between flex__align_center outer-div mb-8">
          <div className="color-gray-8">
            <span className="color-gray-9 text-semi-bold t-reimbursement-amount">
              {totalReimbursementDue}{' '}
              {productId !== ProductIds.Perks && (
                <>
                  {totalReimbursementDue === 1 ? 'employee is' : 'employees are'} due reimbursement for{' '}
                  {formatYearV2(planPeriod.startDate)}:{' '}
                </>
              )}
              {productId === ProductIds.Perks && (
                <>
                  {totalReimbursementDue === 1 ? 'Reimbursement due is' : 'Reimbursements due are'} for{' '}
                  {planPeriod.isContinuous
                    ? parseZoneFormat(planPeriod.startDate) + '-' + 'Continuous'
                    : parseZoneFormat(planPeriod.startDate) + '-' + parseZoneFormat(planPeriod.endDate)}
                </>
              )}
            </span>{' '}
            with a total of{' '}
            <span className="color-gray-9 text-semi-bold t-reimbursement-amount">
              {formatMoney(totalReimbursementAmount)}
            </span>
          </div>
          <Button
            className="c-white"
            type="primary"
            onClick={() =>
              history.push(
                `${ROUTE_PATHS.REIMBURSEMENTS}?tabActiveKey=reimbursements-due&planPeriodId=${planPeriod.id}`,
              )
            }
          >
            Reimburse now
          </Button>
        </div>
      )}
    </>
  )
}

export default TotalReimbursementAmount
